import AccountInventoryService from '@/services/accountinventory.service.js'
import attestationService from '@/services/attestation.service.js'

export default {
  
  searchAccount: (context, data) => {

    context.commit('setLoadingAccountData', true)
    context.commit('setAttestationAccountsData', [])
    console.log('Searching account')
    console.log(data)
    let columnFilters = {}
    let filterObj = {...context.state.accountDataFilters}
    console.log(filterObj)
    
    for (const filter in filterObj) {
      if (Object.hasOwnProperty.call(filterObj, filter)) {
        const filterValue = filterObj[filter]
        if (filterValue) {
          columnFilters[filter] = filterValue
        }
      }
    }

    let params = {
      filters: columnFilters
    }

    if (data && data.hasOwnProperty('paginate') && data['paginate'] == 'next') {
      params['nextPaginationKey'] = context.state.nextPaginationKey
    }

    AccountInventoryService.getAllAccounts(params, (res, err) => {      
      let accounts = res.data.filter( acct => acct.Acct_ID != 'None')
      let accountsWithStatus = []
      console.log('accounts length', accounts)
      if (accounts.length > 0) {
        //
        attestationService.getAttestationStatus(accounts, (err, attestationRes) => {
          accountsWithStatus = accounts.map(( account ) => {
            account['Status'] = 'Not Submitted'
            for (const attestationRecord of attestationRes) {
              if (attestationRecord['Acct_ID'] == account['Acct_ID']) {
                account['Status'] = attestationRecord['Status']
                account['Created_At'] = attestationRecord['Created_At']
              }
            }
            return account
          })
          context.commit('setAttestationAccountsData', accountsWithStatus)
          context.commit('setLoadingAccountData', false)
        })
      }
      
    })
  },

  submitAttestation: (context, data) => {
    context.commit('setSubmittingAttestation', true)
    attestationService.attestationSubmit(data, (err, res) => {
      if (err) {
        // show error
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 10000,
            message: 'An error has occured while submitting your registration. Please contact administrator'
          },
          { root: true }
        )
      } else {
        context.commit('setSnackbar',
          {
            show: true,
            type: 'success',
            timeout: 10000,
            message: 'Your request has been successfully submitted'
          },
          { root: true }
        )
      }
      context.commit('setSubmittingAttestation', false)
      context.commit('clearRequest')
      context.commit('updateAttestedAccount', data)
      vm.$router.push({ path: `/attestation/single` })
    })
  }
}